import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
// 20250620 添加
import Register from '../views/Register.vue'
import Home from '../views/Home.vue'
import Biaodi from '../views/Biaodi.vue'
import Paimaigonggao from '../views/Paimaigonggao.vue'
import GonggaoDetails from '../views/GonggaoDetails.vue'
import Paimaiqiye from '../views/Paimaiqiye.vue'
import QiyeDetails from '../views/QiyeDetails.vue'
import BiaodiDetails from '../views/BiaodiDetails.vue'
import Person from '../views/Person.vue'
import Problem from '../views/Problem.vue'
import Serivce from '../views/Serivce.vue'
import Serivce2 from '../views/Serivce2.vue'
import Serivce3 from '../views/Serivce3.vue'
import Vip from '../views/Vip.vue'
import Progess from '../views/Progess.vue'
import Aboutwe from '../views/Aboutwe.vue'
import Subjects from '../views/Subjects.vue'
import Meetings from '../views/Meetings.vue'
import Partner from '../views/Partner.vue'
import Pcua from '../views/Pcua.vue'
import Company from '../views/Company.vue'

import Synopsis from '../views/About/Synopsis.vue'
import Service from '../views/About/Service.vue'
import Honor from '../views/About/Honor.vue'
import Development from '../views/About/Development.vue'
import Culture from '../views/About/Culture.vue'
import Contact from '../views/About/Contact.vue'

import Pai from '../views/Pai.vue'

import Note from '../views/Note.vue'
import NoteDetails from '../views/NoteDetails.vue'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/biaodi',
		name: 'Biaodi',
		component: Biaodi,
		meta: {
			keepAlive: false
		}
	},

	{
		path: '/biaodiDetails',
		name: 'BiaodiDetails',
		component: BiaodiDetails,
		meta: {
			keepAlive: false
		}
	},
	// {

	// 	path: '/biaodiDetails/:id',  // 动态路由，接受 id 参数
	// 	name: 'BiaodiDetails',
	// 	component: BiaodiDetails,
	// 	meta: {
	// 		keepAlive: false
	// 	}
	// },
	{
		path: '/paimaigonggao',
		name: 'Paimaigonggao',
		component: Paimaigonggao,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/meetings',
		name: 'Meetings',
		component: Meetings,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/subjects',
		name: 'Subjects',
		component: Subjects,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/gonggaoDetails',
		name: 'GonggaoDetails',
		component: GonggaoDetails,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/paimaiqiye',
		name: 'Paimaiqiye',
		component: Paimaiqiye,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/aboutwe',
		name: 'Aboutwe',
		component: Aboutwe,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/qiyeDetails',
		name: 'QiyeDetails',
		component: QiyeDetails,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/person',
		name: 'Person',
		component: Person,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/problem',
		name: 'Problem',
		component: Problem,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/serivce',
		name: 'Serivce',
		component: Serivce,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/serivce2',
		name: 'Serivce2',
		component: Serivce2,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/serivce3',
		name: 'Serivce3',
		component: Serivce3,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/vip',
		name: 'Vip',
		component: Vip,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/progess',
		name: 'Progess',
		component: Progess,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/partner',
		name: 'Partner',
		component: Partner,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/company',
		name: 'Company',
		component: Company,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/pcua',
		name: 'Pcua',
		component: Pcua,
		meta: {
			keepAlive: false
		}
	},

	{
		path: '/synopsis',
		name: 'Synopsis',
		component: Synopsis,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/service',
		name: 'Service',
		component: Service,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/honor',
		name: 'Honor',
		component: Honor,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/development',
		name: 'Development',
		component: Development,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/culture',
		name: 'Culture',
		component: Culture,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/contact',
		name: 'Contact',
		component: Contact,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/pai',
		name: 'Pai',
		component: Pai,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/Note',
		name: 'Note',
		component: Note,
		meta: {
			keepAlive: false
		}
	}, {
		path: '/NoteDetails',
		name: 'NoteDetails',
		component: NoteDetails,
		meta: {
			keepAlive: false
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
